export default "__VITE_ASSET__BScYSHEU__"